import Vue, { CreateElement } from '@src/vue'

import { Component, Prop, Watch } from 'vue-property-decorator'

import './icon.sass'

let iconCache = new Map()

@Component
export class Icon extends Vue {

  @Prop({ required: true })
  name: string

  @Prop({ required: false })
  color: string

  @Prop({ required: false })
  click: () => void

  async mounted () {
    return this.loadImage()
  }

  async updated () {
    return this.loadImage()
  }

  // render does not read the name, so a new name (e.g. the flag of a new language) does not update the icon
  @Watch('name')
  onNameChanged () {
    return this.loadImage()
  }

  async loadImage () {
    const name = this.name
    let icon = `/assets/icon/${name}.svg`

    if (!iconCache.has(icon)) {
      try {
        iconCache.set(icon, fetch(icon).then((data) => {
          return data.text()
        }))
      } catch (exception) {
        iconCache.delete(icon)
      }
    }
    if (iconCache.has(icon)) {
      let innerHTML = await iconCache.get(icon)
      // the name changed while loading, the newer icon is shown instead
      if (name !== this.name) return
      if (innerHTML.indexOf('Cannot GET') < 0) this.$el.innerHTML = innerHTML
    }
  }

  render (h: CreateElement) {
    return (
      <div class='icon' color={this.color} onClick={this.onClick}/>
    )
  }

  protected onClick () {
    if (this.click) {
      this.click()
    }
  }
}
